import { render } from "./CssPanelMediaQueries.vue?vue&type=template&id=46b43d71&scoped=true"
import script from "./CssPanelMediaQueries.vue?vue&type=script&lang=ts"
export * from "./CssPanelMediaQueries.vue?vue&type=script&lang=ts"

import "./CssPanelMediaQueries.vue?vue&type=style&index=0&id=46b43d71&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-46b43d71"

export default script